import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_workspace } from '@/hooks/store/use_slices';

export function WatcherRemoveSplashStatic() {
  const { is_all_data_loaded } = use_slice_workspace(['is_all_data_loaded']);

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (!is_all_data_loaded) return;

    const splash_static = document.getElementById('splash-static');

    if (!splash_static) return;

    splash_static.remove();
  }, [is_all_data_loaded]);

  return null;
}
